import { render, staticRenderFns } from "./TenantStep.vue?vue&type=template&id=025b9ab2&scoped=true&"
import script from "./TenantStep.vue?vue&type=script&lang=js&"
export * from "./TenantStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b9ab2",
  null
  
)

export default component.exports